var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import "./TabButton.css";
/**
 * TabButton component for tab navigation
 */
var TabButton = function (_a) {
    var label = _a.label, isActive = _a.isActive, onClick = _a.onClick;
    return (_jsx("button", __assign({ className: "tab-button ".concat(isActive ? "active" : ""), onClick: onClick }, { children: label })));
};
export default TabButton;
